// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../services/machine-status-build-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getMachineStatusUpdates} from '../../shared/repositories';
import {getUser} from '../../../shared/services/get-user';
import {openFile} from '../../../shared/services/open-file';

export const readMachineStatusUpdates = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(selectedAccounts);

        try {

            const data = await getMachineStatusUpdates(payload);

            dispatch({
                data,
                type: actions.UPDATE_TCSM_MACHINE_STATUS_UPDATES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const exportMachineStatusUpdates = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const {wipFacets} = getState().tcsm.wip;
        const payload = buildPayload(wipFacets.dealers, 'EXCEL', getUser().getLocale(), 'Machine Status Updates');

        try {

            const response = await getMachineStatusUpdates(payload);
            const fileName = getFileName(response);
            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-machine-status-updates.js